import * as AuthActions from './auth.actions';
import { on, createReducer, Action } from '@ngrx/store';
import { IAdminTokenPayload } from '@care-portals/api-interfaces';
import { AppState } from '../app.states';

export const AUTH_FEATURE_KEY = 'auth';

export interface AuthState {
  isAuthenticated: boolean;
  errorMessage: string | null;
  user: IAdminTokenPayload;
  token: string;
  showLoader: boolean;
  redirectUrl: string;
}

const initialState: AuthState = {
  isAuthenticated: false,
  errorMessage: null,
  user: null,
  token: null,
  showLoader: false,
  redirectUrl: null
};

const _reducer = createReducer(
  { ...initialState },

  on(AuthActions.validateAuth, (state: any) => {
    return {
      ...state,
      showLoader: true
    };
  }),

  // no token cookie found
  on(AuthActions.unauthenticatedState, (state: any, { redirectUrl }) => {
    return {
      ...state,
      isAuthenticated: false,
      user: null,
      showLoader: false,
      redirectUrl: redirectUrl
    };
  }),

  on(AuthActions.logIn, (state: AuthState) => {
    return {
      ...state,
      user: null,
      errorMessage: null,
      showLoader: true
    };
  }),

  on(AuthActions.logInSuccess, (state: AuthState, { token }) => {
    return {
      ...state,
      showLoader: false,
      isAuthenticated: true,
      token: token,
      errorMessage: null
    };
  }),

  on(AuthActions.loadUserFailure, (state: AuthState, { error }) => {
    return {
      ...state,
      showLoader: false,
      isAuthenticated: false,
      user: null,
      token: null,
      errorMessage: error.message
    };
  }),

  // fetch user from token
  on(AuthActions.loadUser, (state: any, { token }) => {
    return {
      ...state,
      isAuthenticated: true,
      token: token,
      user: null,
      errorMessage: null,
      showLoader: true
    };
  }),

  // user is fetched and validated
  on(AuthActions.loadUserSuccess, (state: any, { payload }) => {
    return {
      ...state,
      isAuthenticated: true,
      user: payload,
      errorMessage: null,
      showLoader: false
    };
  }),

  on(AuthActions.logInFailure, (state: any, { error }) => {
    return {
      ...state,
      isAuthenticated: false,
      user: null,
      token: null,
      errorMessage: error && error.message,
      showLoader: false
    };
  }),

  on(AuthActions.logOut, (state: any) => {
    return {
      ...initialState
    };
  }),

  on(AuthActions.logOutSuccess, (state: any) => {
    return {
      ...state,
      showLoader: false
    };
  })
);

export function AuthReducer(state: AuthState, action: Action) {
  return _reducer(state, action);
}
